package link.erpango.quip.domain.noteimport

/** What the user confirmed in the bulk review: only selected, complete items. */
data class ImportPlan(
    val vehicles: List<VehicleDraft> = emptyList(),
    val maintenances: List<MaintenanceDraft> = emptyList(),
    val spareParts: List<SparePartDraft> = emptyList(),
) {
    val size: Int get() = vehicles.size + maintenances.size + spareParts.size
}

/** Why an item was not attempted. */
enum class BlockReason {
    /** Its vehicle could not be created (or was not selected). */
    VEHICLE_NOT_CREATED,

    /** A maintenance needs a vehicle and has none. */
    NO_VEHICLE,

    /** A required field is empty. */
    INCOMPLETE,
}

/** Outcome of one item of a bulk import, keyed by draft id. */
sealed interface ItemStatus {
    data object Pending : ItemStatus
    data object InProgress : ItemStatus

    /** [vin] is set for vehicles so later items (and retries) can attach to them. */
    data class Created(val vin: String? = null) : ItemStatus

    /** Already there (same VIN, same maintenance, same spare part): nothing was created. */
    data class AlreadyExisted(val vin: String? = null) : ItemStatus
    data class Failed(val message: String? = null) : ItemStatus
    data class Blocked(val reason: BlockReason) : ItemStatus

    /** Done for good: a retry skips it. */
    val isSettled: Boolean get() = this is Created || this is AlreadyExisted
}
